<template>
  <div class="table">
    <vxe-grid v-bind="gridOptions" ref='xGrid'>
      <template #toolbar_buttons>
        <div style="display: flex;width: 100%;">
          <div>
            <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addUser"
              :disabled="!editTable || !btnEditTable || !btnIsAdmin">{{ $t("message.button.add")
              }}</el-button>
            <el-button class="btn btn8" icon="el-icon-document-delete" @click="removeCheckbox"
              :disabled="!editTable || !btnEditTable || !btnIsAdmin">{{ $t("message.button.delete")
              }}</el-button>

          </div>
          <div style="margin-left: auto;">
            <el-button class="btn btn7" icon="el-icon-document-checked" @click="submit"
              :disabled="!editTable || !btnEditTable || !btnIsAdmin">{{ $t("message.button.save")
              }}</el-button>
            <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave"
              :disabled="!editTable || !btnEditTable || !btnIsAdmin">{{ $t("message.button.cancel")
              }}</el-button>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      cols: "",
      loading: true,

      userId: "",
      gridOptions: {
        toolbarConfig: {
          // zoom: true,
          // custom: true,
          slots: {
            buttons: "toolbar_buttons",
          },
        },
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "560",
        size: "small",
        columns: [],
        data: [],
        editConfig: {
          trigger: "dblclick",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: false,
        },
        sortConfig: {
          trigger: "cell",
        },
      },

      //权限
      removeBtnPriv: false,
      addTableListPriv: false,
      editTable: false,
      btnEditTable: false,
      btnIsAdmin: true, //是否为项目经理
      btnIsProjectAdmin: true, //是否为项目负责人
      isExecuter: true, //是否为执行者
    };
  },
  components: {},
  props: [],
  methods: {
    addUser() {
      //console.log(this.gridOptions.data);
      this.$refs.xGrid.insertAt({}, -1).then((res) => {
        this.$refs.xGrid.setActiveRow(res.row);
      });
    },
    cancel() {
      this.userId = "";
    },

    submit() {
      let updateRecords = this.$refs.xGrid.getUpdateRecords();
      let newRecords = this.$refs.xGrid.getInsertRecords();
      let vm = this;
      var xGrid_ = this.$refs.xGrid;
      var updateBom = [];

      if (updateRecords.length !== 0 || newRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                let obj = {};
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  //console.log(updateRecords[i]);
                  obj.id = updateRecords[i].itemId;
                  //console.log(this.gridOptions.columns[k]);
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      "datetime"
                    ) {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = vm.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                    } else if (
                      //特殊处理执行进度和核检进度取val对应的label值进行保存
                      this.gridOptions.columns[k].attid == 1055004 ||
                      this.gridOptions.columns[k].attid == 1055008
                    ) {
                      let num = updateRecords[i][j];
                      let lists =
                        this.gridOptions.columns[k].editRender.options;
                      lists.forEach((item) => {
                        if (item.value == num) {
                          obj[quantity] = Number(item.label);
                        }
                      });
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  }
                  updateBom.push(obj);
                }
              }
            }
          }
        };
        let newRecordsVal = [];
        if (newRecords.length !== 0) {
          for (var i = 0; i < newRecords.length; i++) {
            let newObj = {};
            for (var key in newRecords[i]) {
              //console.log(newRecords[i][key]);
              if (newRecords[i][key] !== null && key !== "id") {
                //console.log(newRecords[i][key]);
                let num = this.cols[key];
                newObj[num] = newRecords[i][key];
              };
            };
            newRecordsVal.push(newObj);
          };
        };

        var updateBomData = {
          projectId: {
            ...this.$store.state.objectId
            // id: this.$store.state.objId_ + "",
            // classId: this.$store.state.classId_ + "",
            // subClassId: this.$store.state.subClassId_ + "",
          },
          records: this.arrayFilter(updateBom).concat(newRecordsVal),
          tableId: 56,
        };
        axios.post("/ppm/project/saveTable", updateBomData).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.getUserList();
          }
        });
      }
    },
    closeSave() {
      this.getUserList();
    },
    removeCheckbox(grid) {
      //删除
      let obj = {};
      obj.id = this.$store.state.objectId.id + "";
      obj.classId = this.$store.state.objectId.classId + "";
      obj.subClassId = this.$store.state.objectId.subClassId + "";
      //console.log(this.$refs.xGrid);
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      var del_table = [];
      if (removeRow.length == 0) {
        return false;
      } else {
        for (let i = 0; i < removeRow.length; i++) {
          const e = removeRow[i];
          if (e.itemId) {
            del_table.push(e.itemId);
          };
        };
        //console.log(del_table);
        if (del_table.length == 0) {
          this.$refs.xGrid.removeCheckboxRow();
          return false
        };
        let commentsLists = {
          tableId: 56,
          projectId: obj,
          deleteRecordIds: del_table,
        };
        axios.post("/ppm/project/deleteTable", commentsLists).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            //console.log(res);
            this.getUserList();
            this.$refs.xGrid.removeCheckboxRow();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

    async getUserList() {
      let obj = {};
      obj.id = this.$store.state.objectId.id + "";
      obj.classId = this.$store.state.objectId.classId + "";
      obj.subClassId = this.$store.state.objectId.subClassId + "";
      obj.tableId = 56;

      const { data: res } = await this.$http.get(
        `/ppm/project/loadTable${this.params(obj)}`
      );
      // console.log(res);
      let titleColumn = this.getNewTableTitleData(res);
      // this.gridOptions.columns = this.getNewTableTitleData(res);
      this.gridOptions.columns.splice(1, 0, { type: 'seq', width: 50 }),
        titleColumn.map(item => {
          if (item.attid == 1056002) {
            item.width = 80;
            item.minWidth = 80;
          };
          if (item.attid == 1056003) {
            item.width = 480;
            item.minWidth = 480;
          };
          if (item.attid == 1056004) {
            item.width = 480;
            item.minWidth = 480;
          };
        });
      this.gridOptions.columns = titleColumn;
      //console.log(this.gridOptions.columns);
      // this.gridOptions.data = this.getNewTableContentData(res);
      this.$refs.xGrid.loadData(this.getNewTableContentData(res));
      this.cols = res.object.table.columnInfo.ids;
    },

    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      // console.log(priv_);
      let subClass_Id = this.$store.state.objectId.subClassId;
      // console.log(subClass_Id);
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          if (priv_[i].type == 3) {
            this.addTableListPriv = true;
          }
          if (priv_[i].type == 4) {
            this.removeBtnPriv = true;
          }
        }
      };

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.removeBtnPriv = true;
        this.addTableListPriv = true;
      };
    },
  },
  computed: {
    reloadProjectBtnPrv() {
      return this.$store.state.reloadProjectBtnDisable;
    },
    AllProjectBtnPrv() {
      return this.$store.state.AllProjectBtnDisable;
    },
    loadIsProjectAdmin() {
      return this.$store.state.isProjectAdmin;
    },
    loadIsProjectDirector() {
      return this.$store.state.isProjectDirector;
    },
    loadIsProjectExecuters() {
      return this.$store.state.isProjectExecuters;
    },
  },
  watch: {
    reloadProjectBtnPrv: {
      handler(val) {
        this.editTable = val;
      },
      deep: true,
      immediate: true,
    },
    AllProjectBtnPrv: {
      handler(val) {
        this.btnEditTable = val;
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectAdmin: {
      handler(val) {
        this.btnIsProjectAdmin = val;
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectDirector: {
      handler(val) {
        let projectCreatedBy = this.$store.state.projectCreatedBy;
        let userId = window.sessionStorage.getItem("userContext");
        userId = JSON.parse(userId).id;
        if (!this.btnIsProjectAdmin && !val && userId !== projectCreatedBy) {
          this.btnIsAdmin = false;
        } else {
          this.btnIsAdmin = true;
        };
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectExecuters: {
      handler(val) {
        //this.btnIsProjectDirector = val;
        let isSupAdmin = this.$store.state.isSuperAdmin;
        if (!this.btnIsAdmin && !val && !isSupAdmin) {
          this.btnIsAdmin = false;
        } else {
          this.btnIsAdmin = true;
        };
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.getUserList();
    this.loadUserPriv();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
};
</script>
<style scoped>
.table {
  background: #fff;
}
</style>